import React, { useEffect, useState } from "react";
import SideMenu from "../components/SideMenu";
import UserMenu from "../components/UserMenu";
import Header from "../components/Header";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import fingerPrintServices from "../services/fingerPrintService";
import FingerprintScannerLoader from "../components/FingerprintScannerLoader";
import ApiLoader from "../components/ApiLoader";
import REPORT_BASE_URL, { REPORT_BASE_URLDSC } from "../utilities/ReportConfig";
import dscpdf from "../components/pdf/dscpdf.txt";
import DSCSignPopup from "../Modal/DSCSignPopup";

const EndorsementReport = () => {
  const [loading, setLoading] = useState(false);
  const [registrationDetails, setRegistrationDetails] = useState([]);
  const [fingerprintScannerLoading, setFingerprintScannerLoading] =
    useState(false);
  const [refresh, setRefresh] = useState(0);
  const [fingerprintData, setFingerprintData] = useState("");
  const [databaseFingerprint, setDatabaseFingerprint] = useState("");
  const [intializeFingerprintCapture, setIntializeFingerprintCapture] =
    useState(0);
  const [signingInProgress, setSigningInProgress] = useState(false);
  const { dcode, srocode } = useSelector((state) => state?.auth?.userDetails);
  const userDetails = useSelector((state) => state?.auth?.userDetails);

  const [openPdfDialog, setOpenPdfDialog] = useState(false);
  const [selectedPdfFile, setSelectedPdfFile] = useState(null);
  const [currentDSCRegno, setCurrentDSCRegno] = useState(null);
  const [dscRawData, setDscRawData] = useState(null);
  const [dscPde, setDscPde] = useState(null);

  const pdeRegularization = {
    piDcode: "",
    piSrocode: "",
    piRegno: "",
    piRegyear: "",
    bookno: "",
  };
  const [pDERegularizationParams, setPDERegularizationParams] =
    useState(pdeRegularization);

  const {
    callSGIFPGetData,
    successFunc1,
    errorFunc,
    matchFingerPrint,
    succMatch,
    failureFunc,
  } = fingerPrintServices();

  const fetchRegistrationDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/Registration/get_registration_details/${dcode}/${srocode}/ADD`
      );
      if (response.data?.statusCode === 200) {
        setRegistrationDetails(response.data?.data);
      }
    } catch (err) {
      toast.error("Failed to get registration data");
    } finally {
      setLoading(false);
    }
  };

  const handleRegularizePDE = async (data) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/Registration/regularize_pde`,
        data
      );
      console.log("regularize pde response data", response.data);
      if (response.data?.results === 2) {
        toast.error("regularization should be in ascending order");
      } else if (response.data?.results === 0) {
        toast.error("failed to regularize pde please try again");
      } else if (response.data?.results === 1) {
        toast.success("pde regularize successfully");
        setRefresh(refresh + 1);
      } else {
        toast.error("failed to regularize pde please try again");
      }
    } catch (error) {
      console.log("error in regularization pde", error);
      toast.error("Failed to regularize pde please try again");
    }
  };

  const columns = [
    {
      name: "book",
      label: "Book",

      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-center text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "regyear",
      label: "Registration Year",

      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-center text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "regno",
      label: "Registration Number",

      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-center text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "deed",
      label: "Deed",

      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-center text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "subDeed",
      label: "Sub Deed",

      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-center text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "action",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const regno = tableMeta.rowData[2];
          return (
            <button
              variant="contained"
              color="primary"
              onClick={() => handleVerifiyRegularisePDE(regno)}
              className="w-full bg-blue-400 text-sm text-white px-1 3xl:px-2 py-2 rounded hover:bg-blue-700 focus:outline-none"
            >
              Verify
            </button>
          );
        },
      },
    },
    {
      name: "endorsement",
      label: "Endorsement",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const regno = tableMeta.rowData[2];
          return (
            <button
              variant="contained"
              color="primary"
              onClick={() => handlePrintEndorsement(regno)}
              className="w-full bg-blue-400 text-sm text-white px-1 3xl:px-2 py-2 rounded hover:bg-blue-700 focus:outline-none"
            >
              Endorsement
            </button>
          );
        },
      },
    },

    {
      name: "photo",
      label: "Photo",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const regno = tableMeta.rowData[2];
          return (
            <button
              variant="contained"
              color="primary"
              onClick={() => handlePrintPhoto(regno)}
              className="w-full bg-blue-400 text-sm text-white px-1 3xl:px-2 py-2 rounded hover:bg-blue-700 focus:outline-none"
            >
              Photo
            </button>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    elevation: 0,
    rowsPerPageOptions: [10, 15, 25, 50],
    responsive: "standard",
    tableBodyHeight: "auto",
    tableBodyMaxHeight: "auto",
    download: false, // Disables the default download (CSV export) button
    print: false, // Disables the default print button
    viewColumns: false, // Disables the default view columns button
    search: true, // Enables the default search button
    customToolbarSelect: () => null, // Hide default toolbar select (if not needed)
  };

  const getMuiTheme = () =>
    createTheme({
      typography: {
        fontFamily: "Poppins",
      },
      palette: {
        background: {
          paper: "#ffffff",
          default: "#ffffff",
        },
        mode: "light",
      },
      components: {
        MuiTableCell: {
          styleOverrides: {
            head: {
              backgroundColor: "#CACACA !important",
              color: "#000000 !important",
              padding: "1px 1px",
              borderBottom: "2px solid #ECECEC",
              borderRight: "0px solid #ddd",
              fontSize: "5px",
              textAlign: "start",
              "@media (min-width: 768px)": {
                // Medium breakpoint (md)
                fontSize: "inherit", // Keep the original size
              },
              "& .MuiTableSortLabel-root": {
                color: "#000000 !important",
                "&.MuiTableSortLabel-active": {
                  color: "#000000 !important",
                },
              },
              "& .MuiTableSortLabel-icon": {
                color: "#000000 !important",
              },
              "&:hover": {
                color: "#ffffff !important",
                backgroundColor: "#929292 !important",
              },
            },
            body: {
              padding: "3px 4px",
              color: "#000000",
              borderBottom: "1px solid #ECECEC",
              borderRight: "0px solid #000000",
            },
            footer: {
              padding: "7px 15px",
              borderBottom: "0px solid #ECECEC",
            },
          },
        },
      },
    });

  const handleVerifiyRegularisePDE = (regno) => {
    const filteredRecords = registrationDetails.filter(
      (record) => record.regno === regno
    );
    console.log(filteredRecords[0]);
    if (filteredRecords.length > 0) {
      setPDERegularizationParams((prevParams) => ({
        ...prevParams,
        piRegno: filteredRecords[0].regno,
        bookno: filteredRecords[0].book,
        piRegyear: filteredRecords[0].regyear,
      }));
      setIntializeFingerprintCapture(intializeFingerprintCapture + 1);
    } else {
      toast.error("selected pde not found ");
    }
    console.log(`Button clicked for Registration Number: ${regno}`);
    toast.info(`Action triggered for Registration Number: ${regno}`);
  };

  const handlePrintEndorsement = async (regno) => {
    console.log(regno);
    toast.info(`Print Button triggered for Registration Number: ${regno}`);

    const filteredRecords = registrationDetails.filter(
      (record) => record.regno === regno
    );

    if (filteredRecords.length === 0) {
      toast.error(
        "No matching record found for the provided Registration Number."
      );
      return;
    }

    const record = filteredRecords[0]; // Safe access

    try {
      const { deedCode } = record;

      // Check if deedcode is in the specified list
      if (["39", "40", "41", "42", "43"].includes(deedCode)) {
        toast.error(`Does not require printing the report: ${record.subDeed}`);
        return;
      }

      const reportUrl =
        `${REPORT_BASE_URL}/Report/EndorsementReport.aspx?` +
        `pi_docode=${dcode}&pi_srocode=${srocode}` +
        `&pi_regyear=${record.regyear}&pi_bookno=${record.book}` +
        `&pi_regno=${record.regno}&deedcode=${record.deedCode}` +
        `&subdeedcode=${record.subDeedCode}&rpt_Type=${record.appointmentType}&mode=Pre_REGULIZATION`;
      window.open(reportUrl, "_blank");
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.message || "Failed to open the Endorsement Report.");
    }
  };

  const handlePrintPhoto = (regno) => {
    console.log(regno);
    toast.info(`Print Button triggered for Registration Number: ${regno}`);
    const filteredRecords = registrationDetails.filter(
      (record) => record.regno === regno
    );
    console.log(filteredRecords[0]);
    const reportUrl = `${REPORT_BASE_URL}/Report/PhotoCertificateReport.aspx?pi_docode=${dcode}&pi_srocode=${srocode}&pi_regyear=${
      filteredRecords[0].regyear
    }&pi_bookno=${filteredRecords[0].book}&pi_regno=${
      filteredRecords[0].regno
    }&mode=${"Pre_REGULIZATION"}&rpt_Type=${
      filteredRecords[0].appointmentType
    }`;
    window.open(reportUrl, "_blank");
  };

  const captureFingerprint = () => {
    setFingerprintScannerLoading(true);
    callSGIFPGetData((result) => {
      successFunc1(result);
      setFingerprintData(result.ISOTemplateBase64);
      // setImageSrc2("data:image/bmp;base64," + result.BMPBase64);
    }, errorFunc);
  };

  const matchFingerprints = () => {
    setFingerprintScannerLoading(true);
    matchFingerPrint(
      databaseFingerprint,
      fingerprintData,
      (result) => {
        const matchResult = succMatch(result);

        // setMatchResult(matchResult);
        // console.log(matchResult);
        if (matchResult.matched) {
          toast.success("fingerpirnt matched successfully");
          console.log("pde regularize params", pDERegularizationParams);
          handleRegularizePDE(pDERegularizationParams);
        } else {
          toast.error("fingerpirnt does not matched please try again");
        }
        return matchResult;
      },
      (error) => {
        const matchResult = failureFunc(error);
        toast.error("please scan your fingerpirnt again");
        // setMatchResult(matchResult);
        return matchResult;
      }
    ).catch((error) => {
      console.error("Match error:", error);
      toast.error("please scan your fingerpirnt again");
    });
    setFingerprintScannerLoading(false);
  };

  useEffect(() => {
    if (databaseFingerprint) {
      captureFingerprint();
    }
  }, [intializeFingerprintCapture]);

  useEffect(() => {
    if (fingerprintData) {
      matchFingerprints();
    }
  }, [fingerprintData]);

  // useEffect(() => {
  //   fetchRegistrationDetails();
  // }, [refresh]);

  useEffect(() => {
    fetchRegistrationDetails();
  }, []);

  useEffect(() => {
    setDatabaseFingerprint(userDetails?.thumb);
    setPDERegularizationParams({
      ...pDERegularizationParams,
      piDcode: dcode,
      piSrocode: srocode,
    });
  }, [userDetails]);

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  return (
    <>
      {loading && <ApiLoader />}
      {fingerprintScannerLoading && <FingerprintScannerLoader />}
      <div className="flex h-screen">
        <SideMenu />
        <div className="flex-1 flex flex-col">
          <Header />
          <div className="flex flex-1">
            {/* Left Side */}
            <div className="flex-1 align-middle justify-center h-full overflow-auto">
              <div className="py-5 flex justify-center items-center">
                <Box width="100%">
                  <ThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                      title={"Regularize PDE"}
                      data={registrationDetails}
                      columns={columns}
                      options={options}
                    />
                  </ThemeProvider>
                </Box>
              </div>
            </div>
            {/* Right Side */}
            <div className="w-52 3xl:w-64 h-full">
              <UserMenu />
            </div>
          </div>
        </div>
        <DSCSignPopup
          open={openPdfDialog}
          onClose={() => {
            setOpenPdfDialog(false);
            setDscRawData(null);
          }}
          pde={dscPde}
          initialDataToSign={dscRawData}
        />
      </div>
    </>
  );
};

export default EndorsementReport;
